import React from 'react'
import MessageUI from '../../widgets/output/MessageUI'
import PublicPageSF from '../../templates/PublicPageSF'
import ButtonLinkUI from '../../widgets/action/ButtonLinkUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'

const EmailVerificationPageUI = ({context, messageList, errorList}) =>
  <PublicPageSF context={context} className='pg_email_verif' centered={true}>
    {
      (!messageList || !errorList) &&
      <SpinnerComponentUI />
    }
    {
      messageList && errorList &&
      <React.Fragment>
        {
          errorList.length > 0 &&
          <div className='g_text_center g_m_top_100'>
            {errorList[0].message}
          </div>
        }

        {
          !errorList.length &&
          <div className='g_text_center g_m_top_100'>
            <MessageUI messageList={messageList} messageKey='c_email_verified' />
          </div>
        }

        <div className='g_text_center g_m_top_100'>
          <ButtonLinkUI to='/' messageList={messageList} labelKey='c_continue' transparent={true} />
        </div>
      </React.Fragment>
    }
  </PublicPageSF>

export default EmailVerificationPageUI
